import React from 'react';
import { Shield, Settings } from 'lucide-react';

const Footer = ({ onOpenPrivacyPolicy, onOpenAdmin }) => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-slate-950 border-t border-slate-800">
      <div className="container mx-auto px-4 py-8">
        <div className="flex flex-col md:flex-row justify-between items-center gap-4">
          <div className="flex items-center gap-3">
            <img 
              src="./fernando-tech-logo.png" 
              alt="Fernando Tech Logo" 
              className="h-12 w-12 object-contain rounded-lg"
            />
            <div className="flex flex-col">
              <span className="text-white font-bold text-lg">Fernando Tech</span>
              <span className="text-blue-300 text-xs">Suporte Premium</span>
            </div>
          </div>
        </div>

        <div className="mt-6 pt-6 border-t border-slate-800">
          <div className="flex flex-wrap justify-center gap-4 mb-4">
            <button
              onClick={onOpenPrivacyPolicy}
              className="text-cyan-400 hover:text-cyan-300 text-sm flex items-center gap-1 transition-colors"
            >
              <Shield className="w-4 h-4" />
              Política de Privacidade
            </button>
            <span className="text-gray-600">|</span>
            <span className="text-gray-400 text-sm">LGPD Compliant</span>
            {onOpenAdmin && (
              <>
                <span className="text-gray-600">|</span>
                <button
                  onClick={onOpenAdmin}
                  className="text-gray-500 hover:text-cyan-400 text-sm flex items-center gap-1 transition-colors"
                  title="Painel Administrativo"
                >
                  <Settings className="w-4 h-4" />
                  Admin
                </button>
              </>
            )}
          </div>

          <div className="text-center">
            <p className="text-gray-400 text-sm">
              &copy; Desde 2008 | {currentYear} Fernando Tech Soluções. Todos os direitos reservados.
            </p>
            <p className="text-gray-500 text-xs mt-2">
              Fotos meramente ilustrativas.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
